// PersonList.jsx
import React, { useMemo, useState } from 'react';
import api from '../../../services/api';
import { personMatchesSearch, sortPeopleByName } from '../../../utils/personSelect';
import PersonOverlay from './PersonOverlay';
import PersonDetailModal from './PersonDetailModal';
import '../../../css/personList.css';

const PersonList = ({ people, refreshPeopleList, qualifications }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [visibleCount, setVisibleCount] = useState(20);
  const [success, setSuccess] = useState('');
  const [editingPerson, setEditingPerson] = useState(null);
  const [detailPerson, setDetailPerson] = useState(null);

  const filteredPeople = useMemo(
    () => sortPeopleByName(people).filter(person => personMatchesSearch(person, searchTerm)),
    [people, searchTerm],
  );

  const toggleVisible = () => {
    if (visibleCount === filteredPeople.length) {
      setVisibleCount(20);
    } else {
      setVisibleCount(filteredPeople.length);
    }
  };

 
  const handleEdit = async (id) => {
    try {
      
      const response = await api.get(`/people/${id}`);
      setEditingPerson(response.data);
    } catch (error) {
      console.error('Errore nel caricamento della persona:', error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Sei sicuro di voler eliminare questa persona?")) return;
    try {
      await api.delete(`/people/${id}`);
      setSuccess("Persona eliminata con successo!");
      setTimeout(() => setSuccess(""), 2000);
      if (refreshPeopleList) refreshPeopleList();
    } catch (error) {
      console.error("Errore nell'eliminazione della persona:", error);
    }
  };

  const closeOverlay = () => {
    setEditingPerson(null);
  };

  return (
    <div className="person-list">
      <div className="person-list-search">
        <input
          type="text"
          placeholder="Cerca persona..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="person-search"
        />
      </div>
      {success && <p className="success">{success}</p>}

      <div className="person-list-items">
        {filteredPeople.slice(0, visibleCount).map(person => {
          const formattedBirthDate = person.dataNascita
            ? new Date(person.dataNascita).toLocaleDateString('it-IT', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
              })
            : '-';

          return (
            <div key={person.id} className="person-card">
              <div className="person-icon">
                <img
                  src={person.imageUrl || 'https://via.placeholder.com/70'}
                  alt={`${person.nome} ${person.cognome}`}
                  onClick={() => setDetailPerson(person)}
                  style={{ cursor: 'pointer' }}
                  title="Clicca per visualizzare i dettagli"
                />
              </div>
              <div className="person-details">
                <h3>{person.nome} {person.cognome}</h3>
                <div className="person-info">
                  <p>Data di nascita: {formattedBirthDate}</p>
                  <p>Sesso: {person.sesso}</p>
                  {person.email && <p>Email: {person.email}</p>}
                </div>
                {person.qualifications && person.qualifications.length > 0 && (
                  <div className="person-qualifications">
                    {person.qualifications.map(q => (
                      <span key={q.id} className="qualification-chip">{q.name}</span>
                    ))}
                  </div>
                )}
                <div className="person-actions">
                  <button onClick={() => handleEdit(person.id)}>Modifica</button>
                  <button onClick={() => handleDelete(person.id)}>Elimina</button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {filteredPeople.length > 20 && (
        <button onClick={toggleVisible} className="redirect-btn">
          {visibleCount === filteredPeople.length ? 'Mostra meno' : 'Mostra altro'}
        </button>
      )}

      {editingPerson && (
        <PersonOverlay
          person={editingPerson}
          onClose={closeOverlay}
          onUpdate={refreshPeopleList}
          qualifications={qualifications}
        />
      )}

      {detailPerson && (
        <PersonDetailModal
          person={detailPerson}
          onClose={() => setDetailPerson(null)}
        />
      )}
    </div>
  );
};

export default PersonList;
